import { combineActors } from '../stores/actorRunner';
import contactFormActors from './contactForm/actors';
import inboxActors from './inbox/actors';
import tradeInActors from './tradeIn/actors';

export default combineActors(contactFormActors, inboxActors, tradeInActors);
